var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timer row"},[_c('div',{staticClass:"col-12"},[_vm._v("\n    "+_vm._s(_vm.currentTimer)+" "),_c('img',{staticClass:"d-none d-md-inline",attrs:{"src":"/static/alarm.svg"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33b40746","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/games/RoundTimer.vue
// module id = null
// module chunks = 